export default {
    cptDataForm: {
        dataText: '{"value":50}', dataSource: 1, pollTime: 0
    },
    attribute: {
        amplitude: 10, //水波振幅
        shape: 'circle',
        waveNum:2,
        radius: 90,
        label:{
            fontSize: 16,
            color: '#abfff9',
            insideColor:'#fff'
        },
        outline:{
            borderDistance: 0,
            borderWidth: 6,
            borderColorTop: 'rgba(69, 73, 240, 0)',
            borderColorBottom: 'rgba(69, 73, 240, 1)',
            shadowColor: '#000',
        },
        colorTop:'#f46bf5',
        colorBottom:'#1ca3e2',
        backgroundColorTop:'rgba(68, 145, 253, 0)',
        backgroundColorBottom:'rgba(68, 145, 253, 1)',
        cptTableData:[{"name":"值","value":"","namekey":"value"},]
    },
    interaction:{intType: 'none'}
}
